<div class="row">
    <div class="col-xl-6">
        <div class="card card-box p-4 mb-5">
            <div class="d-flex justify-content-between">
                <div class="pr-5">
                    <div class="bg-first text-center text-white font-size-xl d-50 rounded-circle mb-4 mt-1">
                        <fa-icon [icon]="['far', 'bell']"></fa-icon>
                    </div>
                    <h4 class="font-size-xl font-weight-bold mb-2">He lay on his armour-like back, and if he lifted his head.</h4>
                    <button class="btn text-first text-uppercase px-0 font-size-sm">
                    <span class="btn-wrapper--label">
                        <small class="font-weight-bold">View details</small>
                    </span>
                        <span class="btn-wrapper--icon">
                        <small>
                            <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                        </small>
                    </span>
                    </button>
                </div>
                <div class="w-25 d-flex align-items-center">
                    <img alt="..." class="d-block img-fluid" src="assets/images/illustrations/business_plan.svg">
                </div>
            </div>
        </div>
        <div class="card card-box bg-midnight-bloom p-4 mb-5">
            <div class="d-flex justify-content-between">
                <div class="pr-5">
                    <div class="bg-first text-center text-white font-size-xl d-50 rounded-circle mb-4 mt-1">
                        <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                    </div>
                    <h4 class="font-size-xl text-white font-weight-bold mb-2">He lay on his armour-like back, and if he lifted his head.</h4>
                    <button class="btn text-white-50 text-uppercase px-0 font-size-sm">
                    <span class="btn-wrapper--label">
                        <small class="font-weight-bold">View details</small>
                    </span>
                        <span class="btn-wrapper--icon">
                        <small>
                            <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                        </small>
                    </span>
                    </button>
                </div>
                <div class="w-43 d-flex align-items-center">
                    <img alt="..." class="d-block img-fluid" src="assets/images/illustrations/maps.svg">
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box p-4 mb-5">
            <div class="d-flex justify-content-between">
                <div class="pr-5">
                    <div class="bg-warning text-center text-white font-size-xl d-50 rounded-circle mb-4 mt-1">
                        <fa-icon [icon]="['far', 'lightbulb']"></fa-icon>
                    </div>
                    <h4 class="font-size-xl font-weight-bold mb-2">It was popularised in the 1960s with the release of Letraset sheets.</h4>
                    <button class="btn text-warning text-uppercase px-0 font-size-sm">
                    <span class="btn-wrapper--label">
                        <small class="font-weight-bold">View details</small>
                    </span>
                        <span class="btn-wrapper--icon">
                        <small>
                            <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                        </small>
                    </span>
                    </button>
                </div>
                <div class="w-43 d-flex align-items-center">
                    <img alt="..." class="d-block img-fluid" src="assets/images/illustrations/experience_design.svg">
                </div>
            </div>
        </div>
        <div class="card card-box bg-neutral-danger border-danger p-4 mb-5">
            <div class="d-flex justify-content-between">
                <div class="pr-5">
                    <div class="bg-danger text-center text-white font-size-xl d-50 rounded-circle mb-4 mt-1">
                        <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                    </div>
                    <h4 class="font-size-xl text-danger font-weight-bold mb-2">It was popularised in the 1960s with the release of Letraset sheets.</h4>
                    <button class="btn text-danger text-uppercase px-0 font-size-sm">
                    <span class="btn-wrapper--label">
                        <small class="font-weight-bold">View details</small>
                    </span>
                        <span class="btn-wrapper--icon">
                        <small>
                            <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                        </small>
                    </span>
                    </button>
                </div>
                <div class="w-43 d-flex align-items-center">
                    <img alt="..." class="d-block img-fluid" src="assets/images/illustrations/data_points.svg">
                </div>
            </div>
        </div>
    </div>
</div>
